import { useState } from "react";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import DirectionsIcon from "@mui/icons-material/Directions";
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";
import { BRANCHES, directionsUrl, mapEmbedUrl } from "./branches";

function LocationMap() {
  const [active, setActive] = useState(0);
  const branch = BRANCHES[active];

  return (
    <MKBox component="section" py={{ xs: 4, md: 6 }}>
      <Container>
        <MKBox textAlign="center" mb={3} mx="auto" maxWidth="640px">
          <MKTypography variant="h3" mb={1} sx={{ fontSize: { xs: "1.4rem", md: "2rem" } }}>
            Visit us in Rohini
          </MKTypography>
          <MKTypography variant="body2" color="text">
            Both branches are in Pocket 5, Sector 21 — open 24 hours on the helpline.
          </MKTypography>
        </MKBox>

        <Stack alignItems="center" sx={{ mb: 2 }}>
          <Tabs value={active} onChange={(event, value) => setActive(value)} sx={{ minHeight: 40 }}>
            {BRANCHES.map((item) => (
              <Tab
                key={item.id}
                label={item.label}
                sx={{ textTransform: "none", minHeight: 40, fontSize: "0.85rem" }}
              />
            ))}
          </Tabs>
        </Stack>

        <Card
          sx={{
            borderRadius: 3,
            overflow: "hidden",
            boxShadow: "none",
            border: ({ palette: { brand } }) => `1px solid ${brand.line}`,
          }}
        >
          <MKBox
            component="iframe"
            // `key` forces a fresh iframe per branch: changing only the src
            // pushes the old map onto the browser's history, so Back would
            // walk through map states instead of leaving the page.
            key={branch.id}
            title={`Map showing A1 Home Tutors ${branch.label}`}
            src={mapEmbedUrl(branch)}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
            sx={{
              display: "block",
              width: "100%",
              height: { xs: 280, sm: 360, md: 420 },
              border: 0,
            }}
          />

          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            alignItems={{ sm: "center" }}
            justifyContent="space-between"
            sx={{ p: { xs: 2, md: 2.5 } }}
          >
            <MKBox sx={{ minWidth: 0 }}>
              <MKTypography variant="h6" sx={{ fontSize: "0.95rem" }}>
                {branch.label}
              </MKTypography>
              <MKTypography variant="button" color="text">
                {branch.address}
              </MKTypography>
            </MKBox>

            <MKButton
              component="a"
              href={directionsUrl(branch)}
              target="_blank"
              rel="noopener noreferrer"
              variant="gradient"
              color="primary"
              sx={{ flexShrink: 0 }}
            >
              <DirectionsIcon sx={{ mr: 1 }} /> Get directions
            </MKButton>
          </Stack>
        </Card>
      </Container>
    </MKBox>
  );
}

export default LocationMap;
